module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_omiya-f2910b8de4a39ee10e55d7b88d748605.webp";